export default __webpack_public_path__ + "static/media/devguide11.1123be72.md";